/**
 * Colors generated and taken from official cousera CDS (https://github.com/webedx-spark/cds/blob/master/packages/cds-core/src/theme/Colors.ts)
 * To be used as pallette for material-ui. Not all of these colors will be used by our system.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import styles from './Colors.module.scss'

// Our custom rules and colors extracted from our Colors.module.scss
export const core = styles

export const white = '#fff'

export const black = {
  500: styles.black,
  700: '#191919',
}

export const gray = {
  50: '#f9fcfd',
  100: '#f5f7f8',
  200: '#f0f2f3',
  300: '#e5e7e8',
  400: '#c3c5c6',
  500: '#929599',
  600: '#757778',
  700: '#636363',
  800: '#48494a',
  900: '#262828',
}

export const blue = {
  50: '#f3f8ff',
  100: styles.bgLightBlue,
  200: '#d9e8ff',
  300: '#aecfff',
  400: '#86b7ff',
  500: '#3f8dff',
  600: '#0056d2',
  700: '#00419e',
  800: '#003584',
  900: '#00255d',
}

export const purple = {
  50: '#f7f6fe',
  100: '#f1effd',
  200: '#e6e1ff',
  300: '#c9c0ff',
  400: '#b4a6ff',
  500: '#8875ed',
  600: '#6a52e9',
  700: '#4437a8',
  800: styles.purple,
  900: '#2a215d',
}

export const orange = {
  50: '#fff9f0',
  100: '#fff5e6',
  200: '#feebdc',
  300: '#fcdabf',
  400: '#f9b985',
  500: styles.orange,
  600: '#c6824d',
  700: '#a55d3e',
  800: '#884d33',
  900: '#663005',
}

export const yellow = {
  50: styles.bgCream,
  100: '#fdf8e5',
  200: '#fcf4d3',
  300: '#faecb6',
  400: '#f6de80',
  500: styles.yellow,
  600: '#dcb831',
  700: '#c2a63a',
  800: '#7c6919',
  900: '#584c1a',
}

export const aqua = {
  50: '#f5fcff',
  100: '#e5f7ff',
  200: '#d5f3ff',
  300: '#b0e5fb',
  400: '#85d6f9',
  500: '#60caf7',
  600: '#4da2c6',
  700: '#2a7ea3',
  800: '#265f77',
  900: '#174458',
}

export const berry = {
  50: '#fcf7fd',
  100: '#fbf3fc',
  200: '#fce9ff',
  300: '#fbdbff',
  400: '#f7b4ff',
  500: '#d78ae1',
  600: '#b840cd',
  700: '#9829ac',
  800: '#6e1e7c',
  900: '#4e1758',
}

export const pistachio = {
  50: '#f8fcef',
  100: '#f2f9e8',
  200: '#eaf5d8',
  300: '#e0f0c5',
  400: '#c0e18a',
  500: '#a5ca67',
  600: '#84aa45',
  700: '#6a7d4d',
  800: '#4d5a37',
  900: '#353e26',
}

export const green = {
  50: '#f7fbf9',
  100: '#e8f2ee',
  200: '#d0e8dd',
  300: '#b6dbca',
  400: '#99c4b0',
  500: '#60b08b',
  600: '#499471',
  700: styles.green,
  800: '#176340',
  900: '#114a30',
}

export const red = {
  50: '#fdf5f5',
  100: '#fbe6e6',
  200: '#ffd3d3',
  300: '#ffbfc0',
  400: '#ff9899',
  500: '#e56667',
  600: '#dc3334',
  700: styles.red,
  800: '#a90001',
  900: '#710001',
}
